const ImageSlide = () => {

    function animateImage(entries, observer) {
        entries.forEach(entry => {

            var image = entry.target.querySelector('.image-wipe');

            if (entry.isIntersecting) {
        
                if (image) {
                    image.classList.add('image-wipe--active');
                }
            } else {

                if (image) {
                    image.classList.remove('image-wipe--active');
                }
            }
        });
    }

    let options = {
        root: null,
        rootMargin: '0px',
        threshold: 0
    };

    let observer = new IntersectionObserver(animateImage, options);
    const components = document.querySelectorAll('.hero-image');

    components.forEach(component => {
        observer.observe(component);
    })
}

export default ImageSlide;